import React from 'react'
import Icon from '../components/Icon'
import { Link } from 'gatsby'
const InfoBannerHeader = ({ store }) => {
  const whichstore = store
  const topInfoOne = [449]
  const topInfoTwo = [670]
  const topInfoThree = [607]
  const topInfoFour = [557]
  const topInfoFive = [461]
  const topInfoCafe = [
    8,
    17,
    22,
    38,
    113,
    137,
    158,
    167,
    169,
    171,
    172,
    183,
    190,
    192,
    199,
    200,
    206,
    237,
    242,
    261,
    266,
    267,
    284,
    299,
    300,
    301,
    307,
    309,
    313,
    316,
    319,
    340,
    356,
    360,
    384,
    387,
    388,
    404,
    409,
    438,
    439,
    440,
    472,
    522,
    529,
    533,
    575,
    586,
    630,
    647,
    658,
    664,
  ]
  const topInfoMarketKitchen = []
  const topInfoMarketStreet = []
  const topInfoPharmacy = []
  const topInfoDailyClosure = []
  const topInfoFlorists = []

  return (
    <section className="relative flex-1">
      {topInfoOne.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto flex -mt-2 -mr-2 rounded-full shadow-lg">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex items-end flex-1 sm:ml-6 sm:justify-end">
            <div className="flex flex-col items-start justify-center flex-1 p-2 pr-4 bg-white rounded-md shadow-lg sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-base font-semibold leading-tight lg:text-lg text-primary">
                  This store is currently closed for redevelopment
                </h2>
              </div>
              <p className="text-sm font-semibold">
                Your nearest Morrisons are now:
                <br />
              </p>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/205"
              >
                Morrisons Ealing, W5 2ND
              </Link>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/549"
              >
                Morrisons Harrow, HA1 4BB
              </Link>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/382/brentford-waterside"
              >
                Morrisons Brentford Waterside, TW8 8EW
              </Link>
            </div>
          </section>
        </>
      ) : topInfoTwo.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto flex -mt-2 -mr-2 rounded-full shadow-lg">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex items-end flex-1 sm:ml-6 sm:justify-end">
            <div className="flex flex-col items-start justify-center flex-1 p-2 pr-4 bg-white rounded-md shadow-lg sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-base font-semibold leading-tight lg:text-lg text-primary">
                  This store has now closed
                </h2>
              </div>
              <p className="text-sm font-semibold">
                Thank you for your support and we look forward to serving you in
                your nearest Morrisons store located at:
                <br />
              </p>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/649"
              >
                Morrisons Bolsover, S44 6DJ
              </Link>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/27"
              >
                Morrisons Staveley, S43 3UL
              </Link>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/101"
              >
                Morrisons Sheffield - Halfway, S20 8GN
              </Link>
            </div>
          </section>
        </>
      ) : topInfoThree.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto flex -mt-2 -mr-2 rounded-full shadow-lg">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex items-end flex-1 sm:ml-6 sm:justify-end">
            <div className="flex flex-col items-start justify-center flex-1 p-2 pr-4 bg-white rounded-md shadow-lg sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-base font-semibold leading-tight lg:text-lg text-primary">
                  Your Morrisons Royston is now closed
                </h2>
              </div>
              <p className="text-sm font-semibold">
                Thank you for your support and we look forward to serving you in
                your nearest Morrisons store located at:
                <br />
              </p>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/126"
              >
                Morrisons Letchworth, SG6 3TS
              </Link>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/118"
              >
                Morrisons Cambourne, CB23 6EY
              </Link>
            </div>
          </section>
        </>
      ) : topInfoFour.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto flex -mt-2 -mr-2 rounded-full shadow-lg">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex items-end flex-1 sm:ml-6 sm:justify-end">
            <div className="flex flex-col items-start justify-center flex-1 p-2 pr-4 bg-white rounded-md shadow-lg sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-base font-semibold leading-tight lg:text-lg text-primary">
                  This store has now closed
                </h2>
              </div>
              <p className="text-sm font-semibold">
                Thank you for your support and we look forward to serving you in
                your nearest Morrisons store located at:
                <br />
              </p>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/41/preston-riversway"
              >
                Morrisons Preston Riversway, PR2 2YN
              </Link>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/394/bamber-bridge"
              >
                Morrisons Bamber Bridge, PR5 6TP
              </Link>
              <Link
                className="text-sm font-semibold underline text-secondary"
                to="/151/leyland"
              >
                Morrisons Leyland, PR25 3UR
              </Link>
            </div>
          </section>
        </>
      ) : topInfoFive.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto flex -mt-2 -mr-2 rounded-full shadow-lg">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex items-end flex-1 sm:ml-6 sm:justify-end">
            <div className="flex flex-col items-start justify-center flex-1 p-2 pr-4 bg-white rounded-md shadow-lg sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-base font-semibold leading-tight lg:text-lg text-primary">
                  Morrisons Manchester - Grafton Street
                </h2>
              </div>
              <p className="text-sm font-bold">
                Your new look Grafton Street store is now open
              </p>
            </div>
          </section>
        </>
      ) : topInfoCafe.includes(whichstore) ? (
        <>
          <div className="absolute right-0 left-auto flex -mt-2 -mr-2 rounded-full shadow-lg">
            <Icon icon="info" className="h-6 fill-primary" />
          </div>
          <section className="flex items-end flex-1 sm:ml-6 sm:justify-end">
            <div className="flex flex-col items-start justify-center flex-1 p-2 pr-4 bg-white rounded-md shadow-lg sm:flex-initial">
              <div className="mb-1">
                <h2 className="text-base font-semibold leading-tight lg:text-lg text-primary">
                  This store's Cafe will permanently close on the{' '}
                  <span className="whitespace-nowrap">28th April</span>
                </h2>
              </div>
              <p className="text-sm font-bold">
                We apologise for any inconvenience caused.
              </p>
            </div>
          </section>
        </>
      ) : null}
    </section>
  )
}

export default InfoBannerHeader
